import Navbar from "@/components/Layout/Navbar";
import Footer from "@/components/Layout/Footer";
import SEOHead from "@/components/SEOHead";
import { Card, CardContent } from "@/components/ui/card";
import { PAGE_SEO_CONFIG } from "@/lib/seo";

const PrivacyPolicy = () => {
  const seoConfig = PAGE_SEO_CONFIG.privacyPolicy;

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        titleEn={seoConfig.titleEn}
        titleDe={seoConfig.titleDe}
        descriptionEn={seoConfig.descriptionEn}
        descriptionDe={seoConfig.descriptionDe}
        keywords={seoConfig.keywords}
        path={seoConfig.path}
        breadcrumbs={[
          { name: 'Home', nameDE: 'Startseite', url: '/' },
          { name: 'Privacy Policy', nameDE: 'Datenschutz', url: '/privacy-policy' }
        ]}
      />
      
      <Navbar />
      
      <main className="pt-24 pb-32">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="text-center mb-16 pt-16">
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Legal</div>
            <h1 className="text-5xl md:text-6xl font-semibold tracking-[-0.035em] text-balance mb-4">Privacy Policy</h1>
            <p className="text-sm text-muted-foreground">Last updated: August 25, 2024</p>
          </div>

          <Card>
            <CardContent className="p-10 md:p-12">
              <div className="space-y-6 text-foreground/80 leading-relaxed">
                <p>
                  This Privacy Policy describes our policies and procedures on the collection, use, and disclosure of your information when you use the Service and informs you about your privacy rights and how the law protects you.
                </p>

                <p>
                  We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.
                </p>

                <div className="pt-8 border-t border-border/60">
                  <h2 className="text-2xl font-semibold tracking-[-0.02em] mb-6 text-foreground">Interpretation and Definitions</h2>

                  <h3 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-6 mb-3">Interpretation</h3>
                  <p>
                    The words with initial capital letters have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                  </p>

                  <h3 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-8 mb-3">Definitions</h3>
                  <p className="mb-3">For the purposes of this Privacy Policy:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li><strong className="text-foreground">Account</strong> means a unique account created for you to access our Service or parts of our Service.</li>
                    <li><strong className="text-foreground">Company</strong> (referred to as either "the Company", "We", "Us", or "Our" in this Agreement) refers to Nearshore Africa, Germany.</li>
                    <li><strong className="text-foreground">Cookies</strong> are small files placed on your computer, mobile device, or any other device by a website.</li>
                    <li><strong className="text-foreground">Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
                    <li><strong className="text-foreground">Website</strong> refers to Nearshore Africa, accessible from https://nearshore.africa/</li>
                  </ul>
                </div>

                <div className="pt-8 border-t border-border/60">
                  <h2 className="text-2xl font-semibold tracking-[-0.02em] mb-6 text-foreground">Collecting and Using Your Personal Data</h2>

                  <h3 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-6 mb-3">Types of Data Collected</h3>

                  <h4 className="text-base font-semibold text-foreground mt-5 mb-2">Usage Data</h4>
                  <p>Usage Data is collected automatically when using the Service.</p>
                  <p className="mt-2">
                    Usage Data may include information such as your Device's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit.
                  </p>

                  <h3 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-8 mb-3">Tracking Technologies and Cookies</h3>
                  <p>We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information.</p>
                </div>

                <div className="pt-8 border-t border-border/60">
                  <h2 className="text-2xl font-semibold tracking-[-0.02em] mb-6 text-foreground">Compliance with GDPR</h2>
                  <p>The General Data Protection Regulation (GDPR) applies to users in the European Union. Your Rights Under GDPR include:</p>
                  <ul className="list-disc pl-6 space-y-2 mt-3">
                    <li><strong className="text-foreground">Access:</strong> You have the right to access your personal data.</li>
                    <li><strong className="text-foreground">Rectification:</strong> You have the right to have your personal data corrected.</li>
                    <li><strong className="text-foreground">Erasure:</strong> You have the right to request the deletion of your personal data.</li>
                    <li><strong className="text-foreground">Data Portability:</strong> You have the right to receive your personal data in a structured format.</li>
                  </ul>
                </div>

                <div className="pt-8 border-t border-border/60">
                  <h2 className="text-2xl font-semibold tracking-[-0.02em] mb-6 text-foreground">Contact Us</h2>
                  <p>If you have any questions about this Privacy Policy, You can contact us:</p>
                  <p className="mt-2">By email: <a href="mailto:nearshore.africa@evolvice.de" className="text-foreground hover:underline">nearshore.africa@evolvice.de</a></p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
